const FooterSection = () => {
    return (
      <footer>
        <div>2024 &copy; Spots</div>
      </footer>
    );
  };
  
  export default FooterSection;